import React from "react";
import moment from "moment";
import themePropTypes from "../theme-prop-types";

const defultPillWidth = 80;
const pulsePillWidth = 138;

const defultPillHeight = 40;
const pulsePillHeight = 44;

const TimeSlotPicker = ({
  title,
  times,
  selected,
  onSelect,
  components: { Pills },
  invalid,
  usePulseStyles,
  appData
}) => {
  const pillWidth = usePulseStyles ? pulsePillWidth : defultPillWidth;
  const pillHeight = usePulseStyles ? pulsePillHeight : defultPillHeight;
  const dateFormat = usePulseStyles ? "h:mm A" : "h:mma";

  const { visit_times_for } = appData.settings.translations;

  return (
    <>
      <div
        className={`time-slot-picker-title-web-sdk ${
          invalid ? "invalid" : ""
        } `}
      >
        {`${visit_times_for} ${title}*`}
      </div>
      <div className='time-slot-picker-web-sdk'>
        <Pills
          width={pillWidth}
          height={pillHeight}
          justify='center'
          options={times.map(time => ({
            value: time,
            text: moment(time, "YYYY-MM-DDTHH:mm:ss").format(dateFormat)
          }))}
          value={selected}
          onChange={time => onSelect(time)}
          invalid={invalid}
        />
      </div>
    </>
  );
};

TimeSlotPicker.propTypes = themePropTypes.timeSlotPicker;

export default TimeSlotPicker;
